import $http from './../../user-center/http';
import { IpLocationParamsType, IpLocationResType } from './interface/common.d';

class Common {
  /**
   * 根据IP地址获取对应地区
   * http://cowork.yapi.oa.com/project/41/interface/api/496
   *
   * @param {String} param0.ip
   *    如果不传则取来源IP进行判断; eg: 172.217.160.100
   *
   * @returns {Promise.<IpLocationResType | Error>}
   *    IpLocationResType if fulfilled, or an error if rejected.
   *    eg: {country_codes: "cn", show_country_code: "+86"}
   */
  ipLocation({
    ip = '',
  } : IpLocationParamsType): Promise<IpLocationResType | Error> {
    const params = {
      ip,
    };

    return $http
      .post({
        url: 'v2/common/ip/location',
        data: params,
      });
  }
}

export default Common;
